import React from 'react';
import { useUsagePreview } from './context';
import { DOCUMENT_STAGES, euros } from './model';

export function UsagePreviewChat({ onManage }: { onManage: () => void }) {
  const preview = useUsagePreview(), state = preview?.state;
  if (!state || !preview) return null;
  const exhausted = state.remaining === 0;
  const canActivate = exhausted && state.creditCents > 0 && !state.creditsActive;
  const work = state.work;
  const showNotice = exhausted && (work || !state.creditCents || !state.creditsActive || state.creditsNotice);
  return <div className="mx-auto w-full max-w-3xl px-4 pb-1 text-xs sm:px-5">
    <div className="flex items-center gap-3 py-1 text-[11px] text-muted">
      <span title="Simulación local. Al salir recuperas el uso ilimitado de Admin.">Vista previa Admin</span>
      <button type="button" onClick={onManage} className="min-h-9 hover:text-ink underline underline-offset-2">Ajustar</button>
      <button type="button" onClick={preview.exit} className="ml-auto min-h-9 hover:text-ink">Salir de la vista previa</button>
    </div>
    {work && <div className="mb-2 flex flex-wrap items-center justify-between gap-2 rounded-xl border border-line bg-panel px-3 py-1">
      <span>Ejecución simulada · {DOCUMENT_STAGES[work.stage]}</span>
      <button type="button" className="min-h-9 font-semibold text-juris hover:underline" onClick={() => preview.dispatch({ type: 'advance' })}>
        {work.stage === 0 ? 'Simular fin de herramientas' : work.stage === 1 ? 'Simular fin de QA' : 'Completar entrega simulada'}
      </button>
    </div>}
    {showNotice && <div role="status" className="mb-2 rounded-xl border border-line bg-panel px-3 py-2 leading-relaxed">
      <p>{work ? 'La cuota mensual se ha agotado. Esta ejecución puede terminar sin recargar.'
        : state.creditCents > 0 && state.creditsActive ? 'Estás utilizando tus créditos.'
        : 'Has agotado tu capacidad mensual.'}</p>
      {canActivate && <p className="text-muted">Tienes {euros(state.creditCents)} en créditos. Actívalos para enviar nuevos mensajes.</p>}
      {!work && !state.creditCents && <p className="text-muted">Puedes cambiar de plan o añadir créditos para continuar.</p>}
      <div className="flex flex-wrap gap-x-4">
        {canActivate && <button type="button" onClick={() => preview.dispatch({ type: 'activate' })} className="min-h-9 font-semibold text-juris hover:underline">Activar créditos</button>}
        <button type="button" onClick={onManage} className="min-h-9 font-semibold text-juris hover:underline">Gestionar plan y créditos</button>
      </div>
    </div>}
    {state.announcement && <p role="status" className="pb-1 text-[11px] text-muted">{state.announcement}</p>}
  </div>;
}
